import { mq, Skeleton as _Skeleton } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivCarouselWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 32px;
`;

export const CarouselHeadingSkeleton = styled(_Skeleton)`
  height: 38px;
  margin: 0px 0px 16px 32px;

  ${mq.sp} {
    height: 32px;
    margin: 0px 0px 16px 16px;
  }
`;
